// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yqjsnunfuedmiyfujsuw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxanNudW5mdWVkbWl5ZnVqc3V3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg4Mjk4MzAsImV4cCI6MjA1NDQwNTgzMH0.m1akC2qXraO56O-nolZc2EcVhl00d7CJGt7t6dBKlYo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {},
  },
  // Prevent automatic session refresh on window focus to avoid unnecessary DB re-fetches
  auth: {
    autoRefreshToken: true,
    detectSessionInUrl: true,
    persistSession: true,
  },
});